import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gateway-error',
  templateUrl: './gateway-error.component.html',
  styleUrls: ['./gateway-error.component.scss'],
})
export class GatewayErrorComponent {
  constructor() {}
}
